// Polyfills for older Android System WebViews (e.g. the Samsung Galaxy A70 on
// Chromium 91). Imported before everything else in main.tsx.

// `crypto.randomUUID` only exists in Chrome/WebView 92+. On older WebViews it's
// undefined and throws "crypto.randomUUID is not a function", which crashes the
// Chat/Eve page (ChatPage) and the Track event forms. Provide an RFC 4122 v4
// implementation built on crypto.getRandomValues (supported far earlier).
if (
	typeof globalThis.crypto !== "undefined" &&
	typeof globalThis.crypto.randomUUID !== "function" &&
	typeof globalThis.crypto.getRandomValues === "function"
) {
	// Byte → 2-char hex lookup table.
	const byteToHex: string[] = [];
	for (let i = 0; i < 256; i++) {
		byteToHex.push((i + 0x100).toString(16).slice(1));
	}

	const randomUUID =
		(): `${string}-${string}-${string}-${string}-${string}` => {
			const b = new Uint8Array(16);
			globalThis.crypto.getRandomValues(b);
			// Per RFC 4122 §4.4: set the version (4) and variant (10xx) bits.
			b[6] = (b[6] & 0x0f) | 0x40;
			b[8] = (b[8] & 0x3f) | 0x80;
			const h = byteToHex;
			return `${h[b[0]]}${h[b[1]]}${h[b[2]]}${h[b[3]]}-${h[b[4]]}${h[b[5]]}-${h[b[6]]}${h[b[7]]}-${h[b[8]]}${h[b[9]]}-${h[b[10]]}${h[b[11]]}${h[b[12]]}${h[b[13]]}${h[b[14]]}${h[b[15]]}`;
		};

	globalThis.crypto.randomUUID = randomUUID;
}

// `Array.prototype.at` / `String.prototype.at` are Chrome/WebView 92+. On
// Chromium 91 they're undefined; PostHog's bundled web-vitals calls
// `this.o.at(-1)` and throws "this.o.at is not a function". Object.defineProperty
// keeps them non-enumerable (won't show up in for…in).
if (typeof Array.prototype.at !== "function") {
	Object.defineProperty(Array.prototype, "at", {
		value: function at<T>(this: T[], index: number): T | undefined {
			const len = this.length;
			const i = Math.trunc(index) || 0;
			const idx = i < 0 ? len + i : i;
			return idx >= 0 && idx < len ? this[idx] : undefined;
		},
		writable: true,
		configurable: true,
		enumerable: false,
	});
}

// `Object.hasOwn` is Chrome 93+. On Chromium 91 it's undefined and throws
// "Object.hasOwn is not a function", crashing the Chat page.
if (typeof Object.hasOwn !== "function") {
	const ownProp = Object.prototype.hasOwnProperty;
	Object.defineProperty(Object, "hasOwn", {
		value: (target: object, property: PropertyKey): boolean =>
			ownProp.call(target, property),
		writable: true,
		configurable: true,
		enumerable: false,
	});
}

if (typeof String.prototype.at !== "function") {
	Object.defineProperty(String.prototype, "at", {
		value: function at(this: string, index: number): string | undefined {
			const len = this.length;
			const i = Math.trunc(index) || 0;
			const idx = i < 0 ? len + i : i;
			return idx >= 0 && idx < len ? this[idx] : undefined;
		},
		writable: true,
		configurable: true,
		enumerable: false,
	});
}
